<template>
  <generic-modal
    size="large"
    :title="$t('sociocultural representation')"
    icon="quidditch"
    image="/images/icons/archeology-custom.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
    :footer_buttons="footer_buttons"
  >
    <div class="description">
      <div class="ui five item pointing menu" ref="tabs">
        <a class="item active" data-tab="general">
          <i class="circle info icon"></i>
          {{ $t("general information") }}
        </a>
        <a class="item" data-tab="details">
          <i class="list icon"></i>
          {{ $t("motives") }}
        </a>
        <a class="item" data-tab="images">
          <i class="picture icon"></i>
          {{ $t("images") }}
        </a>
        <a class="item" data-tab="sources">
          <i class="asterisk icon"></i>
          {{ $t("references") }}
        </a>
        <a class="item" data-tab="attributes">
          <i class="list ol icon"></i>
          {{ $t("attributes") }}
        </a>
      </div>
      <div class="ui tab segment active" data-tab="general">
        <div class="ui form" ref="form">
          <div class="ui two column grid">
            <div class="column">
              <div class="field">
                <!-- <label for>{{ $t("name") }}</label> -->
                <input
                  type="text"
                  name="name"
                  v-model="piece.name"
                  :placeholder="$t('name')"
                />
              </div>
              <div class="field">
                <div class="three fields">
                  <div class="field">
                    <!-- <label for>{{ $t("site") }}</label> -->
                    <input
                      type="text"
                      name="site"
                      v-model="piece.site"
                      :placeholder="$t('site')"
                    />
                  </div>
                  <div class="field">
                    <!-- <label for>{{ $t("latitude") }}</label> -->
                    <input
                      type="text"
                      name="site_latitude"
                      :placeholder="$t('latitude')"
                      v-model="piece.site_latitude"
                    />
                  </div>
                  <div class="field">
                    <!-- <label for>{{ $t("longitude") }}</label> -->
                    <input
                      type="text"
                      name="site_longitude"
                      :placeholder="$t('longitude')"
                      v-model="piece.site_longitude"
                    />
                  </div>
                </div>
              </div>
              <div class="field">
                <!-- <label for>{{ $t("cultural area") }}</label> -->
                <div class="ui selection dropdown" ref="cultural_area_dropdown">
                  <input type="hidden" name="cultural_area" />
                  <i class="dropdown icon"></i>
                  <div class="default text">{{ $t("cultural area") }}</div>
                  <div class="menu"></div>
                </div>
              </div>
              <div class="field">
                <!-- <label for>{{ $t("cultural sub-area") }}</label> -->
                <div
                  class="ui selection dropdown"
                  ref="cultural_subarea_dropdown"
                >
                  <input type="hidden" name="cultural_subarea" />
                  <i class="dropdown icon"></i>
                  <div class="default text">{{ $t("cultural sub-area") }}</div>
                  <div class="menu"></div>
                </div>
              </div>
              <div class="field">
                <!-- <label for>{{ $t("region") }}</label> -->
                <div class="ui selection dropdown" ref="region_dropdown">
                  <input type="hidden" name="region" />
                  <i class="dropdown icon"></i>
                  <div class="default text">{{ $t("region") }}</div>
                  <div class="menu"></div>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <!-- <label for>{{ $t("origin") }}</label> -->
                <input
                  type="text"
                  name="origin"
                  :placeholder="$t('origin')"
                  v-model="piece.origin"
                />
              </div>
              <div class="field">
                <!-- <label for>{{ $t("temporality") }}</label> -->
                <div class="ui selection dropdown" ref="temporality_dropdown">
                  <input type="hidden" name="temporality" />
                  <i class="dropdown icon"></i>
                  <div class="default text">{{ $t("temporality") }}</div>
                  <div class="menu"></div>
                </div>
              </div>
              <div class="field">
                <!-- <label for>{{ $t("support") }}</label> -->
                <div
                  class="ui multiple selection dropdown"
                  ref="support_dropdown"
                >
                  <input type="hidden" name="support" />
                  <i class="dropdown icon"></i>
                  <div class="default text">{{ $t("support") }}</div>
                  <div class="menu"></div>
                </div>
              </div>
              <div class="field">
                <!-- <label for>{{ $t("style") }}</label> -->
                <div class="ui selection dropdown" ref="style_dropdown">
                  <input type="hidden" name="style" />
                  <i class="dropdown icon"></i>
                  <div class="default text">{{ $t("style") }}</div>
                  <div class="menu"></div>
                </div>
              </div>
            </div>
          </div>
          <!--div class="two fields">
            <div class="eight column wide field">
              <label for>{{ $t("name") }}</label>
              <input type="text" name="name" v-model="piece.name" />
            </div>
          </div>
          <div class="two fields">
            <div class="field">
              <div class="fields">
                <div class="eight wide column field">
                  <label for>{{ $t("site") }}</label>
                  <input type="text" name="site" v-model="piece.site" />
                </div>
                <div class="eight wide column field">
                  <label for>
                    <small>{{ $t("utm coordinates") }}</small>
                  </label>
                  <input
                    type="text"
                    name="site_utm"
                    :placeholder="$t('utm coordinates')"
                    v-model="piece.site_utm"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="three fields">
            <div class="field">
              <label for>{{ $t("cultural area") }}</label>
              <div class="ui selection dropdown" ref="cultural_area_dropdown">
                <input type="hidden" name="cultural_area" />
                <i class="dropdown icon"></i>
                <div class="default text">{{ $t("select one") }}</div>
                <div class="menu"></div>
              </div>
            </div>
            <div class="field">
              <label for>{{ $t("cultural sub-area") }}</label>
              <div class="ui selection dropdown" ref="cultural_subarea_dropdown">
                <input type="hidden" name="cultural_subarea" />
                <i class="dropdown icon"></i>
                <div class="default text">{{ $t("select one") }}</div>
                <div class="menu"></div>
              </div>
            </div>
            <div class="field">
              <label for>{{ $t("region") }}</label>
              <div class="ui selection dropdown" ref="region_dropdown">
                <input type="hidden" name="region" />
                <i class="dropdown icon"></i>
                <div class="default text">{{ $t("select one") }}</div>
                <div class="menu"></div>
              </div>
            </div>
          </div>
          <div class="two fields"></div-->
          <div class="field" style="margin-top:15px">
            <!-- <label for>{{ $t("description") }}</label> -->
            <textarea
              name="description"
              rows="2"
              v-model="piece.description"
              :placeholder="$t('description')"
            ></textarea>
          </div>
          <div class="ui error message"></div>
        </div>
      </div>
      <div class="ui tab segment" data-tab="details">
        <!-- <h4 class="ui dividing header">{{ $t("details") }}</h4> -->
        <div class="ui two column grid">
          <div class="column">
            <generic-catalog
              :title="$t('animals')"
              :attributes="piece.animals"
            />
          </div>
          <div class="column">
            <generic-catalog :title="$t('plants')" :attributes="piece.plants" />
          </div>
          <div class="column">
            <generic-catalog
              :title="$t('landscapes')"
              :attributes="piece.landscapes"
            />
          </div>
          <div class="column">
            <generic-catalog
              :title="$t('objects')"
              :attributes="piece.objects"
            />
          </div>
          <div class="column">
            <generic-catalog
              :title="$t('characters')"
              :attributes="piece.characters"
            />
          </div>
          <!-- <div class="column">
            <generic-catalog
              :title="$t('zoomorphic characters')"
              :attributes="piece.zoomorphic_characters"
            />
          </div>-->
        </div>
      </div>
      <div class="ui tab segment" data-tab="images">
        <!-- <h4 class="ui dividing header">{{ $t("images") }}</h4> -->
        <file-pond
          name="file"
          ref="pond"
          :label-idle="$t('click or drop files here')"
          v-bind:allow-multiple="true"
          v-bind:allow-revert="false"
          maxFileSize="10MB"
          v-bind:server="{
            url: api_host,
            timeout: enterprise_setup.upload_timeout,
            process: {
              url: '/archeology/do-upload-image',
              method: 'POST',
              headers: {
                'x-access-token': token_session,
              },
              withCredentials: false,
            },
          }"
          v-on:error="filepond_error"
          v-on:processfile="filepond_process"
        />
        <div class="ui four cards">
          <div class="card" v-for="(img, idx) in piece.images" :key="idx">
            <div class="image">
              <img
                v-img:name
                class="ui image"
                :src="resource_url(img.server_file)"
              />
            </div>
            <div class="content">
              <div class="ui form">
                <!-- <div class="field">
                  <label for>{{ $t("description") }}</label>
                  <textarea rows="2" v-model="piece.images[idx].description"></textarea>
                </div>-->
                <div class="field">
                  <label for>{{ $t("bibliographic source") }}</label>
                  <input
                    type="text"
                    v-model="piece.images[idx].bibliographic_source"
                  />
                  <!-- <textarea rows="2" v-model="piece.images[idx].bibliographic_source"></textarea> -->
                </div>
              </div>
            </div>
            <div class="ui bottom attached basic buttons">
              <div
                :data-tooltip="$t('download')"
                class="ui button"
                @click.stop="download(img)"
              >
                <i class="ui download icon"></i>
              </div>
              <div
                :data-tooltip="$t('delete')"
                class="ui button"
                @click.stop="remove_image(img, idx)"
              >
                <i class="ui red trash icon"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ui tab segment" data-tab="attributes">
        <generic-container
          icon="list ol"
          :title="$t('attributes')"
          :show_plus="true"
          v-on:add="add_attribute"
        >
          <div class="ui form">
            <div class="fields" v-if="piece.attributes.length > 0">
              <div class="seven column wide field">
                <label for>{{ $t("name") }}</label>
              </div>
              <!-- <div class="seven column wide field">
                <label for>{{ $t("value") }}</label>
              </div>-->
            </div>
            <div
              class="fields"
              v-for="(attribute, index) in piece.attributes"
              v-bind:key="index"
            >
              <div class="fifteen column wide field">
                <textarea
                  name="name"
                  rows="2"
                  v-model="piece.attributes[index].name"
                  :placeholder="$t('attribute')"
                ></textarea>
                <!-- <input
                  type="text"
                  name="name"
                  v-model="piece.attributes[index].name"
                  :placeholder="$t('attribute')"
                />-->
              </div>
              <!-- <div class="seven column wide field">
                <input type="text" name="value" v-model="piece.attributes[index].value" />
              </div>-->
              <div class="two column wide field">
                <div
                  class="ui mini red icon button"
                  v-on:click="remove_attribute(attribute, index)"
                >
                  <i class="trash icon"></i>
                </div>
              </div>
            </div>
          </div>
        </generic-container>
      </div>
      <div class="ui tab segment" data-tab="sources">
        <div class="ui form">
          <generic-container
            icon="asterisk"
            :title="$t('zotero references')"
            :show_plus="true"
            v-on:add="add_source"
          >
            <div class="fields" v-if="piece.sources.length > 0">
              <div class="fifteen column wide field">
                <label for>{{ $t("zotero url") }}</label>
              </div>
            </div>
            <div
              class="fields"
              v-for="(source, index) in piece.sources"
              v-bind:key="index"
            >
              <div class="fourteen column wide field">
                <input type="text" name="name" v-model="piece.sources[index]" />
              </div>
              <div class="two column wide field">
                <div
                  class="ui mini red icon button"
                  v-on:click="remove_source(source, index)"
                >
                  <i class="trash icon"></i>
                </div>
                <div
                  class="ui mini blue icon button"
                  v-on:click="visit_source(source)"
                  v-if="source"
                >
                  <i class="external alternate icon"></i>
                </div>
              </div>
            </div>
          </generic-container>
          <div class="field">
            <div class="fields">
              <div class="sixteen wide column field">
                <label for>{{ $t("deposit") }}</label>
                <input type="text" name="deposit" v-model="piece.deposit" />
              </div>
              <!-- <div class="eight wide column field">
                <label for>
                  <small>{{ $t("utm coordinates") }}</small>
                </label>
                <input
                  type="text"
                  name="deposit_utm"
                  :placeholder="$t('utm coordinates')"
                  v-model="piece.deposit_utm"
                />
              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import {
  local_api,
  enterprise_setup,
  error_toast,
  api_host,
  download_resource,
} from "@/utils";
import GenericModal from "@/components/GenericModal";
import GenericContainer from "@/components/GenericContainer";
import GenericCatalog from "./ArcheologyConfigureCatalog";
import { v4 } from "uuid";
import _ from "lodash";
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";

const FilePond = vueFilePond();

export default {
  components: {
    "generic-modal": GenericModal,
    FilePond,
    GenericCatalog,
    GenericContainer,
  },
  props: {
    piece_in: Object,
  },
  computed: {
    token_session() {
      let token = this.$session.get("token");
      return token;
    },
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  data() {
    return {
      catalogs: {
        cultural_area: [],
        temporality: [],
        motive: [],
        style: [],
        support: [],
      },
      piece: {
        origin: "",
        name: "",
        site: "",
        site_latitude: "",
        site_longitude: "",
        deposit: "",
        deposit_utm: "",
        description: "",
        cultural_area: undefined,
        temporality: undefined,
        support: undefined,
        style: undefined,
        motive: undefined,
        animals: [],
        plants: [],
        landscapes: [],
        objects: [],
        characters: [],
        // zoomorphic_characters: [],
        sources: [],
        images: [],
        attributes: [],
      },
      footer_buttons: [
        {
          color: "orange",
          icon: "trash",
          text: this.$i18n.t("delete"),
          click: this.delete_piece,
          visibility_condition: this.piece_in ? true : false,
        },
      ],
      api_host: api_host,
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let isValid = window.jQuery(vm.$refs.form).form("validate form");
        if (!isValid) reject();
        else {
          local_api(vm, "post", "/archeology/do-save-piece", {
            s: vm.piece,
            u: vm.piece_in ? vm.piece_in.uuid : null,
          })
            .then((piece) => {
              vm.$emit("succedded", piece);
              resolve();
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    },
    destroy() {
      this.$emit("destroy");
      window.jQuery(this.$el).remove();
      this.$destroy();
    },
    filepond_error(a, b) {
      console.log("error", a, b);
    },
    filepond_process(event, inst) {
      // let x1 = this.$refs.pond;
      // console.log(x1, inst);
      if (inst.serverId) {
        let r = JSON.parse(inst.serverId);
        if (!r.success) console.log(r.error);
        else {
          this.piece.images.push({
            file_id: v4(),
            server_file: r.data,
            filename: inst.filename,
            filenameWithoutExtension: inst.filenameWithoutExtension,
            fileExtension: inst.fileExtension,
            fileType: inst.fileType,
            fileSize: inst.fileSize,
            description: "",
            bibliographic_source: "",
          });
        }
        // x1.removeFiles().then((r) => {
        //   console.log(r);
        // });
      }
    },
    setup_catalogs() {
      let vm = this;
      let cats = [
        {
          catalog_name: "cultural_area",
          ref: "cultural_area_dropdown",
          target: "cultural_area",
        },
        /*{
          catalog_name: "temporality",
          ref: "temporality_dropdown",
          target: "temporality",
        },*/
        {
          catalog_name: "support",
          ref: "support_dropdown",
          target: "support",
        },
        {
          catalog_name: "style",
          ref: "style_dropdown",
          target: "style",
        },
        {
          catalog_name: "motive",
          ref: "motive_dropdown",
          target: "motive",
        },
      ];

      cats.map((c) => {
        let values = vm.catalogs[c.catalog_name].map((i) => {
          return { name: i, value: i };
        });
        window
          .jQuery(vm.$refs[c.ref])
          .dropdown("setup menu", { values: values })
          .dropdown({
            onChange(value) {
              vm.piece[c.target] = value;
              if (c.catalog_name == "cultural_area") {
                window
                  .jQuery(vm.$refs.cultural_subarea_dropdown)
                  .dropdown("clear");
                let subarea_values = [];
                let trgt = vm.catalogs.cultural_subareas.find(
                  (s) => s.area_name == value,
                );
                if (trgt)
                  subarea_values = trgt.subareas.map((s) => {
                    return { name: s, value: s };
                  });

                window
                  .jQuery(vm.$refs.cultural_subarea_dropdown)
                  .dropdown("setup menu", { values: subarea_values })
                  .dropdown({
                    onChange(value) {
                      window.jQuery(vm.$refs.region_dropdown).dropdown("clear");
                      vm.piece.cultural_subarea = value;

                      let region_values = [];
                      let trgt = vm.catalogs.regions.find(
                        (s) => s.subarea_name == value,
                      );
                      if (trgt)
                        region_values = trgt.regions.map((s) => {
                          return { name: s, value: s };
                        });

                      window
                        .jQuery(vm.$refs.region_dropdown)
                        .dropdown("setup menu", { values: region_values })
                        .dropdown({
                          onChange(value) {
                            vm.piece.region = value;

                            window
                              .jQuery(vm.$refs.temporality_dropdown)
                              .dropdown("clear");

                            let temporality_values = [];
                            let trgt = vm.catalogs.temporality.find(
                              (s) => s.region_name == value,
                            );
                            if (trgt)
                              temporality_values = trgt.temporality.map((s) => {
                                return { name: s, value: s };
                              });

                            window
                              .jQuery(vm.$refs.temporality_dropdown)
                              .dropdown("setup menu", {
                                values: temporality_values,
                              })
                              .dropdown({
                                onChange(value) {
                                  vm.piece.temporality = value;
                                },
                              });
                          },
                        });
                    },
                  });
              }
            },
          });
      });
    },
    resource_url(file_name) {
      return `${api_host}/public/uploads/archeology/${file_name}`;
    },
    remove_image(img, index) {
      let vm = this;
      this.$alertify.confirm(
        this.$t("are you sure to remove picture?"),
        function() {
          local_api(vm, "post", "/archeology/do-remove-image", {
            u: img.server_file,
          })
            .then(() => {
              vm.piece.images.splice(index, 1);
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
    delete_piece() {
      let vm = this;
      this.$alertify.confirm(
        this.$t("are you sure to remove piece?"),
        function() {
          local_api(vm, "post", "/archeology/do-remove-piece", {
            u: vm.piece_in.uuid,
          })
            .then(() => {
              vm.$emit("deleted", vm.piece_in.uuid);
              window.jQuery(vm.$el).modal("hide");
              // vm.$emit("destroy");
              // vm.$destroy();
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
    add_attribute() {
      this.piece.attributes.push({ name: "", value: "" });
    },
    remove_attribute(attribute, index) {
      this.piece.attributes.splice(index, 1);
    },
    download(image) {
      let url = `${api_host}/public/uploads/archeology/${image.server_file}`;
      download_resource(this, url, image.filename);

      // this.$http({
      //   method: "get",
      //   url: `${api_host}/uploads/archeology/${image.server_file}`,
      //   responseType: "arraybuffer"
      // })
      //   .then((response) => {
      //     let url = `${api_host}/uploads/archeology/${image.server_file}`;
      //     download_resource(this, url, image.filename);

      //     const url = window.URL.createObjectURL(new Blob([response.data]));
      //     const link = document.createElement("a");
      //     link.href = url;
      //     link.setAttribute("download", image.filename); //or any other extension
      //     document.body.appendChild(link);
      //     link.click();
      //   })
      //   .catch(() => console.log("error occured"));
    },
    add_source() {
      this.piece.sources.push("");
    },
    remove_source(source, index) {
      this.piece.sources.splice(index, 1);
    },
    visit_source(source) {
      window.open(source, "_blank");
    },
  },
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.form).form({
      fields: {
        name: ["empty"],
      },
    });

    window
      .jQuery(vm.$refs.tabs)
      .find(".item")
      .tab();

    if (vm.piece_in) {
      vm.piece = _.cloneDeep(vm.piece_in.setup);
      setTimeout(() => {
        window
          .jQuery(vm.$refs.cultural_area_dropdown)
          .dropdown("set selected", vm.piece_in.setup.cultural_area);
        window
          .jQuery(vm.$refs.temporality_dropdown)
          .dropdown("set selected", vm.piece_in.setup.temporality);
        window
          .jQuery(vm.$refs.support_dropdown)
          .dropdown("set selected", vm.piece_in.setup.support.split(","));
        window
          .jQuery(vm.$refs.style_dropdown)
          .dropdown("set selected", vm.piece_in.setup.style);
        window
          .jQuery(vm.$refs.motive_dropdown)
          .dropdown("set selected", vm.piece_in.setup.motive);

        window
          .jQuery(vm.$refs.cultural_subarea_dropdown)
          .dropdown("set selected", vm.piece_in.setup.cultural_subarea);
        window
          .jQuery(vm.$refs.region_dropdown)
          .dropdown("set selected", vm.piece_in.setup.region);
        window
          .jQuery(vm.$refs.temporality_dropdown)
          .dropdown("set selected", vm.piece_in.setup.temporality);
      }, 100);
    }
  },
  created() {
    let vm = this;
    local_api(vm, "post", "/archeology/do-get-configuration")
      .then((r) => {
        vm.catalogs = r.setup.catalogs;
        vm.setup_catalogs();
      })
      .catch((err) => {
        error_toast(err);
      });
  },
  watch: {},
  updated: function() {},
};
</script>
